/**
 * @graphql cc
 */
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import {
	// eslint-disable-next-line graphql-relay-compat/no-import-apollo-functions -- Read http://go/cfe-no-import-apollo-functions
	useQuery,
} from 'react-apollo';

import { isUnauthorizedError } from '@confluence/error-boundary/entry-points/isUnauthorizedError';
import { markErrorAsHandled } from '@confluence/graphql/entry-points/markErrorAsHandled';

import type { AdminKeyEligibilityQueryAdminKeyEligibilityQuery as AdminKeyEligibilityQueryAdminKeyEligibilityQuery$data } from './__types__/AdminKeyEligibilityQueryAdminKeyEligibilityQuery';

export function AdminKeyEligibilityQuery({ children }) {
	const { data, error, loading } = useQuery<AdminKeyEligibilityQueryAdminKeyEligibilityQuery$data>(
		gql`
			query AdminKeyEligibilityQueryAdminKeyEligibilityQuery {
				tenant {
					cloudId
				}
				confluenceTenantContext: confluence_tenantContext {
					editions {
						confluence
					}
				}
				user: confluence_atlassianUser(current: true) {
					id
					confluence {
						roles {
							canBeSuperAdmin
						}
					}
				}
			}
		`,
	);

	let errorToReportToChildren: typeof error;
	if (error) {
		if (isUnauthorizedError(error)) {
			// If `edition` is not permitted to the current user (e.g. anonymous
			// access is not permitted), then the current user is definitely not
			// eligible for admin key. So here an unauthorized error is an expected
			// error.
			markErrorAsHandled(error);
		} else {
			errorToReportToChildren = error;
		}
	}

	return children({
		canBeSuperAdmin: Boolean(data?.user?.confluence?.roles?.canBeSuperAdmin),
		edition: data?.confluenceTenantContext?.editions?.confluence,
		error: errorToReportToChildren,
		loading,
	});
}

AdminKeyEligibilityQuery.propTypes = {
	children: PropTypes.func.isRequired,
};
